'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var childrenSequenceOf = {};

exports.__exports = childrenSequenceOf;
